module.exports = __webpack_public_path__ + "static/media/checkbox-check.995bf266.svg";